<template>
  <div :class="classNames">{{ option.title }}</div>
  <DropdownOptionStock :class="{ 'is-instock': isInStock }" :option="option" />
</template>

<script setup lang="ts">
import { ProductVariant } from '@/__generated__/storefront/graphql';

import DropdownOptionStock from './DropdownOptionStock.vue';

withDefaults(
  defineProps<{
    option: ProductVariant;
    isInStock?: boolean;
    classNames?: string;
  }>(),
  {
    isInStock: true,
    classNames: ''
  }
);
</script>
